import { Editor } from 'tinymce';

// Returns the dynamic entry span the cursor is actually inside, or null if the
// cursor is merely nearby (or not related to a dsv span at all).
export function getDynamicSpanAtCursor(ed: Editor, rng: Range) {
	const contentContainer = ed.contentDocument.getElementById('tinymce');
	const span = ed.dom.getParent(rng.startContainer, '[data-id]');
	if (!span || !contentContainer.contains(span) || contentContainer === span) return null;

	return span as HTMLElement;
}
